import React from 'react';
import {useCurrentFrame} from 'remotion';
import {AppTimerDial, type TimerPhase} from '../app/AppTimerDial';

const ROUND_DURATION_SECONDS = 3;
const TOTAL_ROUNDS = 8;
const TOTAL_RESTS = 7;
const SLIDE_FRAMES = 150;
const READY_CUTOFF = 1 / 9;
const COMPLETION_CUTOFF = 7 / 9;

export const Story2TimerDial: React.FC<{type?: string}> = ({type = 'TABATA'}) => {
  const frame = useCurrentFrame();
  const value = Math.min(frame / SLIDE_FRAMES, 1);

  const isReady = value < READY_CUTOFF;
  const isCompleted = value >= COMPLETION_CUTOFF;
  const runningProgress = Math.max(
    0,
    Math.min(1, (value - READY_CUTOFF) / (COMPLETION_CUTOFF - READY_CUTOFF)),
  );

  const remainingSeconds = isCompleted
    ? 0
    : isReady
      ? ROUND_DURATION_SECONDS
      : Math.max(
          0,
          Math.min(
            ROUND_DURATION_SECONDS,
            ROUND_DURATION_SECONDS -
              Math.floor(runningProgress * ROUND_DURATION_SECONDS),
          ),
        );

  const ringProgress = isCompleted ? 1 : isReady ? 0 : runningProgress;
  const completedRounds = isCompleted ? 1 : 0;
  const phase: TimerPhase = isCompleted ? 'completed' : isReady ? 'ready' : 'running';

  return (
    <AppTimerDial
      type={type}
      progress={ringProgress}
      remainingSeconds={remainingSeconds}
      rounds={completedRounds}
      totalRounds={TOTAL_ROUNDS}
      restsDone={0}
      totalRests={TOTAL_RESTS}
      totalSecondsLabel="03:50"
      phase={phase}
    />
  );
};
